import React, { PropTypes } from 'react';
import FullDatePicker from '../../form/FullDatePicker';
import ParticipantsSelect from '../../Participants/ParticipantsSelect';
import BingoVoting from './votings/BingoVoting';
import BestPlayerVoting from './votings/BestPlayerVoting';
import MatchResultVoting from './votings/MatchResultVoting';
import Collapse from 'components/Collapse';
import RaisedButton from 'material-ui/RaisedButton';
import { Container } from 'react-grid-system';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import IconButton from 'material-ui/IconButton';
import IconClose from '../../Icons/IconClose';

export default class EventsEditForm extends React.Component {
  static propTypes = {
    fetch: PropTypes.func,
    title: PropTypes.string.isRequired,
    goIndex: PropTypes.func.isRequired,
    model: PropTypes.object,
    isNew: PropTypes.any,
    save: PropTypes.func.isRequired
  };

  state = {
    processingBingo: false
  };

  componentWillMount() {
    let { params: { id } = {}, fetch } = this.props || {};
    if (fetch) {
      fetch(id);
    }
  }

  componentWillUnmount() {
    let { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  }

  // eslint-disable-next-line no-unused-vars
  formSubmitted(res) {
    this.props.goIndex();
  }

  processSubmit() {
    return (
      this.props
        .handleSubmit(data => this.props.save(data))(this.props.values)
        .then(response => this.formSubmitted(response))
        // eslint-disable-next-line no-console
        .catch(e => console.log(e))
    );
  }

  onClose() {
    let { goIndex } = this.props;

    if (goIndex) {
      goIndex();
    }
  }

  getStyle() {
    return {
      participantContainer: {
        display: 'flex',
        justifyContent: 'space-between'
      },
      participantItem: {
        width: '40%',
        flexBasis: 'auto'
      }
    };
  }

  _renderHeader() {
    let { title } = this.props;

    return (
      <LoggedAppBar
        isStatic={true}
        title={title}
        iconElementRight={
          <IconButton onClick={() => this.onClose()}>
            <IconClose />
          </IconButton>
        }
      />
    );
  }

  render() {
    let {
      isNew,
      fields: { first_partc, second_partc, start_time, end_time },
      submitting,
      bingoConfig,
    } = this.props;

    let style = this.getStyle();

    return (
      <Container style={{ margin: 0, padding: 30 }}>
        <form onSubmit={() => this.processSubmit()}>
          {this._renderHeader()}
          <div>
            <div style={style.participantContainer}>
              <ParticipantsSelect
                label="First participant"
                style={style.participantItem}
                {...first_partc}
              />
              <ParticipantsSelect
                label="Second participant"
                style={style.participantItem}
                {...second_partc}
              />
            </div>

            <FullDatePicker
              label="Start time"
              required
              min={new Date()}
              {...start_time}
            />
            <FullDatePicker
              label="End time"
              required
              min={start_time.value}
              {...end_time}
            />
            <div style={{ textAlign: 'center' }}>
              <RaisedButton
                label={'Save'}
                primary={true}
                disabled={submitting}
                onClick={() => this.processSubmit()}
              />
            </div>
          </div>
          <br />
          <br />
          {isNew ? null : (
            <Container>
              <Collapse label="Competition voting">
                <BingoVoting configOptions={bingoConfig} />
              </Collapse>
              <br />
              <Collapse label="Best player voting">
                <BestPlayerVoting />
              </Collapse>
              <br />
              <Collapse label="Matchresult voting">
                <MatchResultVoting />
              </Collapse>
            </Container>
          )}
        </form>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/EventsEditForm.jsx